import Button from './Button';

/** Single-value filter; caller retains its value and filtering logic. */
export default function SegmentedControl({label, value, onValueChange, options, className=''}) {
  const enabled=options.filter(option=>!option.disabled);
  const move=(event, current)=>{
    const i=enabled.findIndex(option=>option.value===current);
    const index={ArrowRight:(i+1)%enabled.length,ArrowLeft:(i-1+enabled.length)%enabled.length,Home:0,End:enabled.length-1}[event.key];
    if(index===undefined || !enabled.length)return;
    event.preventDefault();
    const next=enabled[index];
    event.currentTarget.parentElement.querySelectorAll('button')[options.indexOf(next)]?.focus();
    onValueChange(next.value);
  };
  return <div role="group" aria-label={label} className={`fc-segmented ${className}`}>
    {options.map(option=><Button key={option.value} variant="segment" size="compact" disabled={option.disabled}
      aria-pressed={value===option.value} onKeyDown={event=>move(event,option.value)}
      onClick={()=>onValueChange(option.value)}>{option.label}</Button>)}
  </div>;
}
